










import { Component, Vue } from "vue-property-decorator";
import {
  GROUP_ONE,
  GroupOneData,
  GroupVariables
} from "@/graphql/query/group/one";
import { AppUserBuilding } from "@/pages/AppAccount/AppAccountRooms.vue";
import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";

export interface Group {
  id: string;
  name: string;
  isPrivileged: boolean;
  allowRescueOperations: boolean;
}

@Component({
  components: {
    AuthTab
  },
  apollo: {
    group: {
      query: GROUP_ONE,
      variables(): GroupVariables {
        return { id: this.$apollo.vm.$route.params.groupId };
      },
      update(data: GroupOneData): Group {
        return data.group;
      }
    }
  }
})
export default class TabFrame extends Vue {
  group: AppUserBuilding | null = null;
  get tabItems(): AuthTabItem[] {
    if (this.$apollo.loading) {
      return [];
    }
    const resourceId = this.$route.params.groupId;
    return [
      {
        name: "group-details",
        title: "グループ情報",
        scopes: [{ resource: "Group", resourceId, action: "management" }]
      },
      {
        name: "group-users",
        title: "ユーザーリスト",
        scopes: [{ resource: "Group", resourceId, action: "management" }]
      },
      {
        name: "group-newusers",
        title: "ユーザー登録",
        scopes: [{ resource: "Group", resourceId, action: "management" }]
      }
    ];
  }
}
